import { HTMLAttributes } from 'react';

import { trpc } from '@web/lib/trpc';

import { Skeleton } from './skeleton';
import { Media } from './media';

export function File({
  fileId,
  className,
}: HTMLAttributes<HTMLImageElement> & { fileId: string }) {
  const { data: attachment } = trpc.messaging.getMediaFile.useQuery({
    fileId: fileId,
  }) as { data: { type: string; fileContents: string } | null };

  return attachment?.type && attachment.fileContents ? (
    <Media
      file={{ type: attachment.type, content: attachment.fileContents }}
      className={className}
    />
  ) : (
    <Skeleton className={className} />
  );
}